import * as admins from './admins';
import * as recipes from './recipes';
import * as weeklyMenu from './weekly-menu';
import * as measurements from './measurements';

export const api = { recipes, weeklyMenu, admins, measurements };
